import styled from 'styled-components'

import { mainColors } from '../../styles/colors'
import { _L_Medium, _M_Medium, _M_Normal, _S_Normal, _XS_Normal } from '../../styles/typography'
import { mobileMediaQuery } from '../../utils/mediaQueries'
import { NoResults } from '../NoResults'
import { DetailedReview, REVIEW_CARD_MAX_WIDTH } from '../ReviewTimeline'

export const ReviewCardContainer = styled.div`
  max-width: ${REVIEW_CARD_MAX_WIDTH}px;

  &:not(:last-of-type) {
    border-bottom: 1px solid ${mainColors.neutralMedium};
    padding-bottom: 12px;
    margin-bottom: 12px;
  }
`

export const ReviewBreakdownContainer = styled.div<{
  shouldDisplayAsColumn?: boolean
}>`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  ${({ shouldDisplayAsColumn }) => shouldDisplayAsColumn && 'flex-direction: column'};

  ${mobileMediaQuery`
    flex-flow: column;
    align-items: flex-start;
  `}
`

export const DetailedRatingsRowContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 30px;
  flex: 0 0 auto;
`

export const DetailedRatingsColumnsContainer = styled.div<{ mini?: boolean }>`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  flex-wrap: wrap;
  gap: ${({ mini }) => (mini ? '6px 16px' : '16px 20px')};
  width: 100%;
`

export const DetailedReviewWithBorder = styled(DetailedReview)`
  border: 1px solid ${mainColors.neutralMedium};
  border-radius: 4px;
  padding: 4px 8px;

  > div {
    justify-content: space-between !important;
  }
`

export const OverallContainer = styled.div`
  padding-right: 20px;
`

export const ReviewRatingLabel = styled.p`
  ${_M_Medium};
`

export const ChannelIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;

  > svg {
    width: 32px;
    height: 32px;
  }
`

export const BookingDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 16px;
`

export const ReviewDate = styled.div`
  ${_XS_Normal};
  color: ${mainColors.neutralExtremelyDark};
  text-align: right;
`

export const GuestName = styled.p`
  ${_M_Medium};
  margin-bottom: 2px;
`

export const GuestNameLink = styled(GuestName)`
  ${_L_Medium};
  color: ${mainColors.accentMedium};
  cursor: pointer;
`

export const BookingPeriodDates = styled.p`
  ${_S_Normal};
  color: ${mainColors.neutralExtremelyDark};
`

export const BookingPeriodDatesLink = styled.a`
  ${_S_Normal};
  color: ${mainColors.accentMedium};
`

export const ReviewCommentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const ReviewCommentHeader = styled.div`
  ${_M_Medium};
  margin-bottom: 2px;
`

export const ReviewComment = styled.div`
  ${_M_Normal};
  color: ${mainColors.neutralExtremelyDark};
`

export const ReviewCommentTruncated = styled(ReviewComment)`
  overflow: hidden;
`

export const MiniCardContainer = styled.div`
  border: 1px solid ${mainColors.neutralMedium};
  border-radius: 8px;
  padding: 16px;
  cursor: auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 400px;
`

export const NoComment = styled(NoResults)`
  width: 100%;
  height: 100%;
  padding: 0;
  align-items: center;
  justify-content: center;
`
